export default {
  namespaced: true,
  state: {
    isStudentCloseModal: false,
    showModalPopupNotice: false,

    showModalCustomerFeedback: false,
    showCfeForm: false,
    showCfeConfirmation: false,
    showCfeHideTrainerModal: false,
    customerFeedbackSetting: null,
  },
  getters: {
    isModalShowing: (state) => {
      return state.showModalPopupNotice || state.showModalCustomerFeedback;
    },
    isCustomerFeedbackModalEnabled: (state) => {
      return !state.customerFeedbackSetting?.is_disabled && state.customerFeedbackSetting?.is_due_for_display;
    }
  },
  mutations: {
    setIsStudentCloseModal(state, payload) {
      state.isStudentCloseModal = payload;
    },
    setShowModalPopupNotice(state, payload) {
      state.showModalPopupNotice = payload;
    },
    setShowModalCustomerFeedback(state, payload) {
      state.showModalCustomerFeedback = payload;
    },
    setCustomerFeedbackSetting(state, payload) {
      state.customerFeedbackSetting = payload;
    },
    setShowCfeForm(state, payload) {
      state.showCfeForm = payload;
    },
    setShowCfeConfirmation(state, payload) {
      state.showCfeConfirmation = payload;
    },
    setShowCfeHideTrainerModal(state, payload) {
      state.showCfeHideTrainerModal = payload;
    },
    setAllModal(state, payload) {
      state.showModalPopupNotice = payload;
      state.showModalCustomerFeedback = payload;
    }
  },
  actions: {}
};
